// Display order for label-value options; callers sort copies so category order stays intact.
export function compareLabelNames(a: { name: string }, b: { name: string }): number {
  return a.name.localeCompare(b.name, undefined, { sensitivity: 'base', numeric: true });
}
